module.exports = __webpack_public_path__ + "img/file-word.82a0ec4f.svg";